import EventActionProto from '../event-action-proto'
import {BUS_SESSION_CUSTOM_FIELDS_CHANGE} from "../../gd/bus/bus-event-type";

module.exports = class EventCustomFieldsResetByCompany extends EventActionProto {

    constructor(uid:string, data:any) {
        super(uid, data, false);
        this.restartApps = ['organization-settings-custom-fields'];
    }

    validate() {
        return true;
    }

    process() {
        gd.session.customFields.resetAndMarkOldModelsAsDeleted(this.data.customFields, this.data.companyId)

        gd.bus.triggerEvent(BUS_SESSION_CUSTOM_FIELDS_CHANGE)

        super.process()
    }
}

